module.exports = __webpack_public_path__ + "static/media/close-icon.5b900a4e.svg";